(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('loadingPanel', loadingPanel);

    loadingPanel.$inject = ['$document'];
    function loadingPanel($document) {
        var $ = angular.element,
            body = $($document.prop('body')),
            panel = $('<div class="loading-panel"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i><img src="images/logo-ca-sq.png" /></div>'),
            refCount = 0;

        return function loadingPanel(show) {
            refCount = Math.max(0, refCount + (show ? 1 : -1));
            refCount === 1 ? body.append(panel) : refCount === 0 ? panel.detach() : null;
        }
    }
})();